module.exports = __webpack_public_path__ + "assets/img/ru-f71bef8c.png";